// extracted by mini-css-extract-plugin
export default {"MenuContainer":"styles_MenuContainer__k0h52","logoBox":"styles_logoBox__BdOVD"};